import { useMutation } from '@tanstack/react-query';

import { camelizeKeys, decamelizeKeys } from 'humps';
import { useApiClient } from '../../../hooks';

const useCreateLinkTokenMutation = (accessToken) => {
  const apiClient = useApiClient(accessToken);
  const mutation = useMutation(({ organizationId, integrationName, schema }) =>
    apiClient
      .post('/sync/link_tokens', decamelizeKeys({ integrationName, schema }), {
        params: decamelizeKeys({ organizationId })
      })
      .then(({ data }) => camelizeKeys(data))
  );

  return mutation;
};

export { useCreateLinkTokenMutation };
